import React from 'react';
import PropTypes from 'prop-types';
import LandingPageTemplate from '../../components/04_templates/PageLayouts/LandingPage';
import Paragraphs from '../../components/02_molecules/Paragraphs';
import '../../styles/styles.scss';

const PublicationLandingPage = ({ blocks = [], layout = 'left' }) => {
  return (
    <LandingPageTemplate>
      <Paragraphs blocks={blocks} layout={layout} />
    </LandingPageTemplate>
  );
};

PublicationLandingPage.getInitialProps = async (args) => {
  return await Paragraphs.getInitialProps(args);
};

PublicationLandingPage.propTypes = {
  entity: PropTypes.shape({}),
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      blockType: PropTypes.string.isRequired,
    }),
  ),
  layout: PropTypes.string,
};

export default PublicationLandingPage;
